export enum JeopardyLevel {
  Error = 1,
  Warning = 2,
}
